module.exports = __webpack_public_path__ + "img/BX.57a7b273.jpg";